export default {"src":"/_next/static/media/horse_riding.cda2d583.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};